var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.935,
    height: 55.935,
    viewBox: "0 0 55.935 55.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-symbol-of-an-auricular-inside-a-circle",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M27.969,0A27.968,27.968,0,1,0,55.936,27.968,27.969,27.969,0,0,0,27.969,0ZM42.737,40.808,40.5,43.048a4.127,4.127,0,0,1-1.608.648A26.413,26.413,0,0,1,12.237,16.981a4.169,4.169,0,0,1,.656-1.536l2.239-2.24a3.741,3.741,0,0,1,3.5-.826l.471.157a4.425,4.425,0,0,1,2.557,2.7l1.126,4.134a4.055,4.055,0,0,1-.925,3.54l-1.5,1.5A15.882,15.882,0,0,0,31.53,35.582l1.495-1.5a4.053,4.053,0,0,1,3.541-.929l4.134,1.13a4.43,4.43,0,0,1,2.7,2.554l.157.478A3.745,3.745,0,0,1,42.737,40.808Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.c53bb1562fc2b73cc66f665b38922ca3.svg";
export { ForwardRef as ReactComponent };